import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useIntl } from 'gatsby-plugin-intl';

const SkipToContent = styled.a`
  background: ${themeGet('colors.blacks.1')};
  color: ${themeGet('colors.white')};
  position: absolute;
  left: 0;
  transform: translateY(-100%);
  transition: transform 0.3s;
  z-index: 1000;

  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 18px;
  font-size: 14px;
  letter-spacing: 0.2px;
  text-align: center;
  font-weight: ${themeGet('fontWeights.medium')};

  height: 46px;
  width: 100%;
  min-width: 110px;
  max-width: 163px;

  &:hover {
    color: ${themeGet('colors.white')};
    text-decoration: underline;
  }

  &:focus {
    transform: translateY(0%);
  }
`;

const SkipToContentLink = () => {
  const intl = useIntl();

  return (
    <SkipToContent href="#main-content">
      {intl.locale === 'en' ? 'Skip to content' : 'Aller au contenu'}
    </SkipToContent>
  );
};

export default SkipToContentLink;
